<ol class='breadcrumb d-print-none'>
  <li class='breadcrumb-item'><a routerLink='/'>Home</a></li>
  <li class='breadcrumb-item' *ngFor='let breadcrumb of data.breadcrumbs'>
    <a [routerLink]='[breadcrumb.url]'>{{ breadcrumb.label }}</a>
  </li>
</ol>